import {gql} from '@apollo/client';

export const GET_WORKER_OUTREACH = gql`
  query GetWorkerOutreach($wiwUserId: String!) {
    getWorkerOutreach(wiwUserId: $wiwUserId)
  }
`;

export const UPDATE_OUTREACH_STATUS = gql`
  mutation UpdateOutreachStatus($entityId: String!, $status: OutreachStatus!) {
    updateOutreachStatus(entityId: $entityId, status: $status)
  }
`;
